import { SeoHead } from '../components/SeoHead';

export function SearchPage() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-16">
      <SeoHead
        title="Buscar eventos em Joinville — Joyn"
        description="Encontre shows, festivais e eventos em Joinville usando a busca do Joyn."
      />
      <h1 className="text-3xl font-bold">Busca</h1>
      <p className="text-muted-foreground mt-2">Resultados de busca — em breve.</p>
    </div>
  );
}
